import React from "react";

export default function UserProfilesPagination({
  page,
  total,
  limit,
  onPageChange,
}) {
  const totalPages = Math.ceil(total / limit);
  const canPrev = page > 1;
  const canNext = page < totalPages;
  const from = (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);

  return (
    <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="text-xs sm:text-sm font-medium text-gray-600 order-2 sm:order-1">
        Page <span className="font-bold text-gray-900">{page}</span> of{" "}
        <span className="font-bold text-gray-900">{totalPages}</span> · Total{" "}
        <span className="font-bold text-red-600">{total}</span> users
      </div>
      <div className="flex gap-2 items-center order-1 sm:order-2">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={!canPrev}
          className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
            !canPrev
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
          }`}>
          Previous
        </button>
        <span className="text-xs sm:text-sm text-gray-600 min-w-[120px] text-center">
          {from}–{to} of {total}
        </span>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={!canNext}
          className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
            !canNext
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
          }`}>
          Next
        </button>
      </div>
    </div>
  );
}
